import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizacionesService } from '@app/_services/organizaciones.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '../_services';
import { AgentesService } from '@app/_services/agentes.service';

@Component({
  selector: 'app-agentes-tipos',
  templateUrl: './agentes-tipos.component.html',
})
export class AgentesTiposComponent implements OnInit {

  public dataTiposAgentes: [];
  lang;
  public seleccionados: number[] = [];
  private translate: TranslateService;
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;

  constructor(
    private agentesService: AgentesService,
    private menuService: MenuService,
    public router: Router,
    translate: TranslateService,
    private translateService: TranslateService,
    private modalService: NgbModal,
  ) {
    this.translate = translate;
    this.menuService.titulo = this.translate.instant('agentes.tiposagentes');
    this.agentesService.getAllTiposAgente().subscribe((result) => {
      this.dataTiposAgentes = result.data;
    })
  }

  ngOnInit(): void {
    this.lang = this.translateService.getDefaultLang();
    this.agentesService.getAllTiposAgente().subscribe((result) => {
      this.dataTiposAgentes = result.data;
      console.log('dataTiposAgentes Loaded :'+this.dataTiposAgentes.length.toString())
  
    });
  }

  onClickNuevo() {
    this.router.navigate(['agentes-tipos/crear/']);
  }

  onClickEditar() {
    console.log(this.seleccionados[0]);
    if (this.seleccionados.length>0) {
      this.router.navigate(['agentes-tipos/editar/', this.seleccionados[0]]);
    }
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['agentes-tipos/editar/', this.seleccionados[0]]);
    }
  }

  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  private eliminarRegistro(contentloading) {
    this.agentesService.deleteTipos({ codigos: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.agentesService.getAllTiposAgente().subscribe((result) => {
            this.dataTiposAgentes = result.data;
          }
          );
        }
        this.modalReferenceloading.close();
      }
    );
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }
}
